export const CAT_COLORS = {
  'G-Sec': '#378ADD',
  'T-Bill': '#1D9E75',
  SDL: '#639922',
  'PSU Bond': '#BA7517',
  'NCD / Corp Bond': '#D85A30',
  'Debt Mutual Fund': '#7F77DD',
  'Bank FD / CD': '#D4537E',
  'Small Savings': '#888780',
  'Sovereign Gold Bond': '#EF9F27',
  'InvIT / REIT': '#5DCAA5',
  'Subordinated / AT1': '#E24B4A',
  'Structured / MLD': '#AFA9EC',
};

export const BADGE_CLASS = {
  'G-Sec': 'fipb-badge-gsec',
  'T-Bill': 'fipb-badge-tbill',
  SDL: 'fipb-badge-sdl',
  'PSU Bond': 'fipb-badge-psu',
  'NCD / Corp Bond': 'fipb-badge-ncd',
  'Debt Mutual Fund': 'fipb-badge-mf',
  'Bank FD / CD': 'fipb-badge-fd',
  'Small Savings': 'fipb-badge-ss',
  'Sovereign Gold Bond': 'fipb-badge-sgb',
  'InvIT / REIT': 'fipb-badge-invit',
  'Subordinated / AT1': 'fipb-badge-sub',
  'Structured / MLD': 'fipb-badge-mld',
};

export const DEFAULT_FORM = {
  risk_profile: 'moderate',
  investment_amount_inr: 1000000,
  horizon: 'medium',
  rbi_rate_view: 'pause',
  tax_bracket: 'medium',
  investor_type: 'retail',
  esg_preference: false,
  include_ai: true,
};

export const RISK_PROFILE_OPTIONS = [
  { value: 'conservative', label: 'Conservative — Rakshak' },
  { value: 'moderate', label: 'Moderate — Santulit' },
  { value: 'balanced', label: 'Balanced — Vikassheel' },
  { value: 'growth', label: 'Growth — Labhdayak' },
  { value: 'aggressive', label: 'Aggressive — Utsahi' },
];

export const HORIZON_OPTIONS = [
  { value: 'short', label: 'Short — 1 to 3 years' },
  { value: 'medium', label: 'Medium — 3 to 7 years' },
  { value: 'long', label: 'Long — 7 to 15 years' },
  { value: 'very_long', label: 'Very long — 15+ years' },
];

export const RBI_VIEW_OPTIONS = [
  { value: 'hike', label: 'Rate hike cycle' },
  { value: 'pause', label: 'Rate pause / neutral' },
  { value: 'cut', label: 'Rate cut cycle' },
];

export const TAX_OPTIONS = [
  { value: 'high', label: 'High — 30%+' },
  { value: 'medium', label: 'Medium — 20–30%' },
  { value: 'low', label: 'Low / tax-exempt' },
];

export const INVESTOR_OPTIONS = [
  { value: 'retail', label: 'Retail' },
  { value: 'hni', label: 'HNI' },
  { value: 'corporate', label: 'Corporate treasury' },
  { value: 'nri', label: 'NRI investor' },
];

export function fmtInr(n) {
  return `₹${Math.round(Number(n) || 0).toLocaleString('en-IN')}`;
}

export function fmtPct(n) {
  return `${Number(n).toFixed(2)}%`;
}

export function ratingClass(rating) {
  if (!rating) return 'fipb-rating-hy';
  if (rating.includes('SOV')) return 'fipb-rating-sov';
  if (rating.includes('AAA')) return 'fipb-rating-aaa';
  if (rating.includes('AA')) return 'fipb-rating-aa';
  if (rating.includes('A') && !rating.includes('B')) return 'fipb-rating-a';
  return 'fipb-rating-hy';
}
